import { filterMailMergeOptions, getMailMergeValue } from '@repo/crm-atoms';
import { AutoComplete } from 'antd';
import useMailMergeFields from 'automations/hooks/useMailMergeFields';
import { useCallback, useEffect, useState } from 'react';

export default function MailMergeInput({
  onChange,
  disabled,
  initialValue,
  allowedDataTypes,
}: {
  onChange: (value: string) => void,
  disabled: boolean,
  initialValue?: string,
  allowedDataTypes: string[]
}) {
  const { options } = useMailMergeFields({
    allowedDataTypes,
  });
  const [inputValue, setInputValue] = useState(initialValue ?? '');

  const handleSelect = useCallback((value: string) => {
    setInputValue(getMailMergeValue(value));
  }, []);

  const handleChange = useCallback((value: string) => {
    setInputValue(value);
  }, []);

  useEffect(() => {
    if (inputValue !== initialValue && !disabled) {
      onChange?.(inputValue);
    }
  }, [onChange, inputValue, initialValue, disabled]);

  const filteredOptions = filterMailMergeOptions(options, inputValue);

  return (
    <AutoComplete
      options={filteredOptions}
      value={inputValue}
      style={{ width: 200 }}
      onSelect={handleSelect}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
